import React, {} from 'react';

// services
import showMenuItem from '../../../utils/appbar';
import { logout, logoutSuperUser } from '@services/auth';
import { getUserProfile } from '@services/auth';

// styles
import * as S from './styles';

const Logout = () => {
  const userProfile = getUserProfile();

  /**
   * logoutOptions
   * return the logouts options to be filtered by user profile
   */
  const logoutOptions = [
    {
      title: 'Sair da plataforma',
      onClick: () => logout(),
      userType: 'LOGOUT'
    },
    {
      title: 'Sair da plataforma',
      onClick: () => logoutSuperUser(),
      userType: 'LOGOUT_SUPER_USER'
    }
  ];

  return logoutOptions
    .filter(filteredItem => showMenuItem(userProfile, filteredItem.userType))
    .map((item, index) => {
      return (
        <S.Logout
          key={`${item.task}-${index}`}
          onClick={args => {
            item.onClick(args);
          }}
        >
          {item.title}
        </S.Logout>
      );
    })
};

export default Logout;